import { section } from "@/neon";
import { add } from "@fluorescent/dom";

import isFirstSectionOnHomepage from "@/lib/homePage";
import { animateImageHero } from "@/lib/animation";

section("image-hero", {
  onLoad() {
    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, "first-full-height");
    }
    this.animateImageHero = animateImageHero(this.container);
  },

  onUnload() {
    this.animateImageHero?.destroy();
  },
});
